export const CSS_CLASS_NAMES = {
  TRY_IT_OUT_HEADER: 'try-it-out-header',
  TRY_IT_OUT_BUTTON: 'try-it-out-button',
  AUTH_MODE_SELECTOR: 'auth-mode-selector',
} as const;

export const CSS_SELECTORS = {
  SWAGGER_UI_TRY_IT_OUT_BUTTON: 'button.btn.try-out__btn',
  BODY_PARAM_CANCEL_BUTTON: 'button.btn.cancel.body-param__example-edit',
} as const;

export const DATA_ATTRIBUTES = {
  SELECTED: 'data-selected',
  AUTH_MODE: 'data-auth-mode',
  PROCESSED: 'data-try-it-out-processed',
} as const;

export const HTTP_HEADERS = {
  CSRF_TOKEN: 'x-csrf-token',
} as const;

export const SWAGGER_EXTENSIONS = {
  TRY_IT_OUT_HAS_SUPPORTED_AUTH_TYPES: 'x-try-it-out-has-supported-auth-types',
  TRY_IT_OUT_RISK_LEVEL: 'x-try-it-out-risk-level',
  TRY_IT_OUT_URL: 'x-try-it-out-url',
} as const;
